import { alpha } from "@mui/system";

const styles = (props) => ({
	appBar: { top: 0, display: "flex" },
	toolbar: {
		width: "100%",
		height: 0,
		display: "flex",
		justifyContent: "space-between",
	},
	toolbarNavigate: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		gap: 3,
	},
	logo: {
		width: "150px",
		height: "auto",
		marginTop: " 7px",
	},
	paperAvatar: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		background: "transparent",
		maxWidth: "260px",
		width: "100%",
		p: 1,
		gap: 1,
		cursor: "pointer",
		ml: "4px",
		borderRadius: "20px",
		border: `1px solid ${props.palette.white.main}54`,
		"&:hover": {
			background: `linear-gradient(90deg, ${alpha(
				props.palette.buttonHoverGradient.dark,
				0.5
			)} 0%, ${alpha(props.palette.buttonHoverGradient.light, 0.5)} 100%)`,
		},
	},
	titleAvatar: {
		maxWidth: "200px",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		ml: 1,
		fontSize: "1rem",
		fontWeight: 500,
		color: props.palette.white.main,
	},
	boxAvatar: {
		display: "flex",
		flexDirection: "row",
		gap: 3,
		alignItems: "center",
	},
	containerValueProgress: {
		top: 0,
		left: 0,
		bottom: 0,
		right: 0,
		position: "absolute",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	imgLogo: { width: "200px", height: "auto" },
	IconButtonLogo: {
		padding: 0,
		borderRadius: 0,
		width: "220px",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		transform: "translateX(-20px)",
	},
	lastItemBreadcrumbs: {
		color: "text.primary",
		textTransform: "capitalize",
	},
	itemBreadcrumbs: {
		textTransform: "capitalize",
	},
	Breadcrumbs: {
		marginBottom: "30px",
		marginTop: "-10px",
	},
	topContent: { height: "0", width: "98vw" },
	main: {
		flexGrow: 1,
		p: 2,
		borderTopLeftRadius: 8,
	},
	containerFilter: {
		display: "flex",
		flexDirection: "column",
		width: "100%",
	},
	iconFloat: { position: "fixed", bottom: 16, right: 16, zIndex: 1300 },
	containerDrawer: {
		minWidth: "300px",
		display: "flex",
		flexDirection: "column",
	},
	dateTimePickerTextField: {
		size: "small",
		sx: {
			fontSize: "0.75rem",
			"& .MuiInputBase-input": {
				padding: "6px 8px",
				fontSize: "0.75rem",
			},
			"& .MuiInputLabel-root": {
				fontSize: "0.75rem",
			},
		},
	},
	textAutocomplete: {
		fontSize: "0.75rem", // diminui fonte geral
		"& .MuiInputBase-input": {
			padding: "6px 8px", // padding interno reduzido
			fontSize: "0.75rem", // fonte do input
		},
		"& .MuiInputLabel-root": {
			fontSize: "0.75rem", // fonte da label
		},
	},
	containerToGoBack: { width: "100%", display: "flex", padding: 1 },
	tab: {
		minWidth: "60px",
		height: "100%",
		maxWidth: "200px",
		justifyContent: "start",
		color: props.palette.white.main,
		opacity: 0.9,
		fontSize: "0.875 rem",
		"&:hover": {
			backgroundColor: props.palette.background.hover,
		},
	},
	menuItem: {
		minWidth: "220px",
		display: "flex",
		alignItems: "center",
	},
	containerNotificacoes: {
		width: "89%",
		display: "flex",
		flexDirection: "column",
	},
	iconLink: { marginLeft: "10px" },

	textClientNotificacoes: {
		fontWeight: "bold",
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
	},
	linkNotificacao: {
		"&:hover": {
			textDecoration: "none",
		},
	},
	containerMenuNotificacoes: {
		maxHeight: "300px",
		maxWidth: "300px",
		overflow: "auto",
	},
	badgeColor: {
		"& .MuiBadge-badge": {
			fontSize: 9,
			height: 15,
			minWidth: 15,
			backgroundColor: props.palette.white.main,
			color: props.palette.black.main,
		},
	},
});

export default styles;
